import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 25,
  },

  cardDestacado: {
    backgroundColor: "#077A97",
  },

  iconDestacado: {
    tintColor: "#FFF",
  },

  textDestacado: {
    color: "#FFF",
  },

  card: {
    marginTop: 8,
    width: 66,
    height: 66,
    paddingVertical: 6,
    borderWidth: 0.2,
    borderRadius: 8,
    borderColor: "#077A97",
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
  },

  img: {
    width: 24,
    height: 24,
    tintColor: "#077A97",
  },

  textCard: {
    fontFamily: "Poppins_400Regular",
    color: "#077A97",
    fontSize: 10,
    textTransform: "uppercase",
    margin: 6,
  },
  contentCard: {
    width: 108,
    overflow: "hidden",
    height: "auto",
    justifyContent: "space-around",
  },
});

export default styles;
